import React from "react";

export const Hobbs = () => {
  return (
    <div className="top-indent sign-half">
      <div className="stretch">
        <span className="title">Hobbs:</span>
      </div>

      <div className="stretch inline-item">
        <span className="title">Start:</span>
        &nbsp;
        <span className="sign-line" />
      </div>

      <div className="stretch inline-item">
        <span className="title">End:</span>
        &nbsp;
        <span className="sign-line" />
      </div>

      <div className="stretch inline-item">
        <span className="title">Total:</span>
        &nbsp;
        <span className="sign-line" />
      </div>
    </div>
  )}
